import React, { PureComponent } from 'react'
import { View, Platform } from 'react-native'
import styled from 'styled-components/native'
import theme from '../../../../styles/theme'
import { BarChart, Grid } from 'react-native-svg-charts'
import { Text as SvgText, G, Rect } from 'react-native-svg'

const ContainerRow = styled(View)`
  flex: 1;
  flex-direction: row;
  padding: ${theme.gutterUnit * 2}px;
  background: ${theme.colours.white};
`

const Container = styled(View)`
  flex-grow: 1;
  background: ${theme.colours.white};
`

const YAxisLabelWidth = 140
export default class ShareholderReturn extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      isMeasurable: false,
      width: 0,
      height: 0
    }
  }

  handleLayout = event => {
    if (this.state.isMeasurable) return // layout was already called
    const { width, height } = event.nativeEvent.layout
    this.setState({
      isMeasurable: true,
      width: width - theme.gutterUnit * 4,
      height: height - theme.gutterUnit * 4
    })
  }

  getChart (data, currentTeam) {
    return {
      chartProps: {
        style: {
          width: this.state.width,
          height: this.state.height + 30
        },
        data: data.map(({ name, team, value }) => ({
          value: value / 1000000,
          current: team === currentTeam,
          name,
          svg: { fill: team === currentTeam ? theme.colours.chart.orange : theme.colours.chart.blue }
        })),
        horizontal: true,
        spacingInner: 0.4,
        gridMin: 0,
        gridMax: Math.ceil(Math.max.apply(Math, data.map(({ value }) => value / 1000000))),
        numberOfTicks: Math.ceil(Math.max.apply(Math, data.map(({ value }) => value / 1000000))),
        contentInset: {
          top: 5,
          bottom: 5,
          left: YAxisLabelWidth + 10,
          right: 10
        },
        yAccessor: ({ item }) => item.value
      }
    }
  }

  render () {
    const { chartProps } = this.getChart(this.props.data, this.props.currentTeam)
    const cutOff = 50
    const Labels = ({ x, y, bandwidth, data }) => (
      data.map(({ value }, index) => {
        return (
          <SvgText
            key={index}
            x={x(value) + cutOff > this.state.width ? x(value) - 10 : x(value) + 10}
            y={y(index) + (bandwidth / 2)}
            fontFamily={Platform.select({ web: 'ubuntu-bold' })}// TODO fontFamily fix
            fontSize={14}
            fontWeight='bold'
            fill={x(value) + cutOff > this.state.width ? '#fff' : '#888'}
            alignmentBaseline='middle'
            textAnchor={x(value) + cutOff > this.state.width ? 'end' : 'start'}
          >
            {Math.round(value * 10) / 10 + 'm'}
          </SvgText>
        )
      })
    )
    const TeamLabels = ({ x, y, bandwidth, data }) => (
      data.map(({ name, current, value }, index) => {
        const height = bandwidth + 10 > 40 ? 40 : bandwidth + 10
        return (
          <G
            key={index}
            x={x(0) - 10}
            width={YAxisLabelWidth}
            y={y(index) + (bandwidth / 2)}
          >
            {current &&
              <Rect
                width={YAxisLabelWidth}
                height={height}
                fill={theme.colours.orange}
                x={-YAxisLabelWidth}
                y={-height / 2}
                ry={height / 2}
                rx={height / 2}
              />}
            <SvgText
              fontSize={14}
              width={YAxisLabelWidth}
              fontFamily={Platform.select({ web: 'ubuntu-medium' })} // TODO fontFamily fix
              fill={current ? theme.colours.white : theme.colours.black}
              alignmentBaseline='middle'
              textAnchor='middle'
              x={-YAxisLabelWidth / 2}
            >
              {name.toUpperCase()}
            </SvgText>
          </G>
        )
      })
    )
    return (
      <ContainerRow>
        <Container onLayout={this.handleLayout}>
          {this.state.isMeasurable &&
            <BarChart {...chartProps}>
              <Grid direction={Grid.Direction.VERTICAL} svg={{ stroke: '#eee' }} />
              <Labels />
              <TeamLabels />
            </BarChart>}
        </Container>
      </ContainerRow>
    )
  }
}
